import { site } from "../content";

export default function Marquee() {
  const row = [...site.marquee, ...site.marquee];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-graphite/60 py-7 backdrop-blur-md"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-10 font-serif text-2xl italic text-bone/70 md:text-3xl">
              {item}
            </span>
            <span className="text-sm text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
